import {combineReducers} from '@reduxjs/toolkit';
import userReducer from './slices/authSlice';
// import projectReducer from './slices/projectSlice';
// import employeeReducer from './slices/employeeSlice';
// import projectAnalyticsReducer from './slices/projectAnalyticsSlice';
// import userStoryReducer from './slices/userStorySlice';
// import profileReducer from './slices/myProfileSlice';
// import dashboardReducer from './slices/dashboardSlice';

const rootReducer = combineReducers({
  user: userReducer,
  // project: projectReducer,
  // employee: employeeReducer,
  // projectAnalytics: projectAnalyticsReducer,
  // userStory: userStoryReducer,
  // profile: profileReducer,
  // dashboard: dashboardReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
